/** The two coverage fields that describe the latest finalized snapshot. */
export interface SnapshotStatus {
  snapshot_rev?: number | null;
  snapshot_complete?: boolean;
}

/**
 * True only once a finalized snapshot exists and is known to have nothing
 * left to heal. A missing field (an older backend) reads as unsettled, so a
 * poller never stops early against a deploy that hasn't shipped them yet.
 */
export function isSnapshotSettled(status: SnapshotStatus | null | undefined): boolean {
  return status != null && status.snapshot_rev != null && status.snapshot_complete === true;
}
